module.exports = __webpack_public_path__ + "static/img/formBg.330b3bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/formBg.jpg
// module id = 238
// module chunks = 1